<template>
  <div class="w-full relative mt-5">
    <div class="absolute text-white text-sm -top-6 tracking-[1.96px]">{{ value ? '' : 'START' }}</div>

    <div
      class="progressbar bg-white h-[0.5rem] w-full relative transition-all before:bg-app-secondary-8-blue--medium-aquamarine before:content-[''] before:absolute before:top-0 before:left-0 before:h-2"
      :style="cssProps"
      role="progressbar"
      :aria-valuenow="value"
      aria-valuemin="0"
      aria-valuemax="100"
    >
      <div class="progressbar__value absolute text-white text-sm -top-6 tracking-[1.96px]">{{ value ? `${value}%` : '' }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  value: { type: Number, required: false, default: 0 },
})

const cssProps = computed(() => ({
  '--progress-bar__value': `calc(${props.value}%)`,
  '--progress-bar__offset': `${props.value === 100 ? '40px' : '12px'}`,
}))
</script>

<style scoped lang="scss">
.progressbar {
  &:before {
    width: var(--progress-bar__value);
  }

  &__value {
    left: calc(var(--progress-bar__value) - var(--progress-bar__offset));
  }
}
</style>
